import React from 'react';
import { Construction } from 'lucide-react';

export default function IntelligenceDashboard() {
  return (
    <div className="p-8 max-w-4xl mx-auto text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#193D6D]/10 mb-4">
        <Construction className="w-8 h-8 text-[#193D6D]" />
      </div>
      <h2 className="text-2xl font-bold text-[#193D6D] mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>IntelligenceDashboard</h2>
      <p className="text-gray-500">Este módulo está em desenvolvimento.</p>
    </div>
  );
}
